import { useQuery } from '@apollo/client'
import { tribesQuery } from '../../../appsync/graphql/student'
import { formatAppsyncErrors } from '../../../appsync/utils'

const useStudentGetTribesQuery = ({ isStudent, otherSkipConditions }) => {
  const {
    loading,
    error: rawError = null,
    data: rawData = {},
  } = useQuery(tribesQuery, {
    variables: { getTribes: true, isStudent },
    skip: otherSkipConditions,
  })
  const data = rawData?.getTribes ?? []
  const error = rawError ? formatAppsyncErrors(rawError) : null

  return { data, loading, error }
}

export default useStudentGetTribesQuery
